export class UpdateOrderCancellationPolicyStatusEntity {
  isEnabled?: boolean
}
